import React from 'react';

const HandwrittingBackground = ({ imageUrl }) => {
    return (
        <div className="handwritting">
            <img src={imageUrl} alt="" />
        </div>
    );
};

export default HandwrittingBackground;